<template>
    <div class="em-preparo" role="status" aria-live="polite" data-teste="empresa-em-preparo">
        <div class="em-preparo__conteudo">
            <v-progress-circular indeterminate size="56" width="4" color="primary" class="mb-6" />

            <h1 class="em-preparo__titulo mb-3">Preparando o hdocs para a sua empresa</h1>

            <p class="em-preparo__texto mb-2">
                É a primeira vez que a sua empresa abre o hdocs. Estamos criando o espaço dela — leva poucos minutos, em geral até 2.
            </p>
            <p class="em-preparo__apoio mb-6">
                Não precisa fazer nada: esta tela confere sozinha e abre o sistema assim que terminar.
            </p>

            <p class="em-preparo__apoio mb-4" data-teste="contagem-em-preparo">
                {{ verificando ? 'Verificando…' : `Verificando de novo em ${restante} s` }}
            </p>

            <div class="d-flex justify-center flex-wrap ga-2">
                <v-btn color="primary" variant="tonal" :loading="verificando" @click="verificar">Verificar agora</v-btn>
                <v-btn variant="text" @click="voltarParaOAdmin()">Voltar para o Admin</v-btn>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { verPreparacao } from '@/services/api/hdocs/sessao.js';
import { segundosDeEspera } from '@/services/emPreparo.js';
import { voltarParaOAdmin } from '@/services/sso.js';

// Pagina de espera de uma corporacao recem-cadastrada (ver corporacaoEmPreparo.js). Pergunta a API, a cada `segundosDeEspera`, se as tabelas ja
// existem; quando existem, recarrega a pagina -- tudo o que as telas pediram enquanto isso foi respondido com o aviso e nunca chegou a resolver.
const restante = ref(segundosDeEspera.value);
const verificando = ref(false);
let relogio = null;

async function verificar() {
    if (verificando.value) return;

    verificando.value = true;

    try {
        const resposta = await verPreparacao();

        if (resposta?.pronta) {
            window.location.reload();

            return;
        }
    } catch {
        // Sem resposta (rede, API reiniciando): continua tentando, a pessoa nao precisa ver erro nenhum.
    } finally {
        verificando.value = false;
        restante.value = segundosDeEspera.value;
    }
}

onMounted(() => {
    relogio = setInterval(() => {
        if (verificando.value) return;

        restante.value -= 1;
        if (restante.value <= 0) verificar();
    }, 1000);
});

onBeforeUnmount(() => clearInterval(relogio));
</script>

<style scoped>
/* Cobre a tela inteira, menu e cabecalho inclusos: a pessoa nao tem nada util a clicar enquanto a empresa nao esta pronta. */
.em-preparo {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: var(--hdocs-superficie);
}

.em-preparo__conteudo {
    max-width: 520px;
    text-align: center;
}

.em-preparo__titulo {
    font-size: 1.35rem;
    font-weight: 600;
    color: var(--hdocs-texto-forte);
}

.em-preparo__texto {
    color: var(--hdocs-texto-forte);
}

.em-preparo__apoio {
    color: var(--hdocs-texto-fraco);
    font-size: 0.875rem;
}
</style>
